<div class="nothing-found-container">
  <div class="mt-5 mb-5">
    <h2 class="text-center">{{title ? title : 'Keine Ergebnisse...'}}</h2>
    <p class="text-muted text-center">{{subtitle ? subtitle : 'Es konnten keine Elemente gefunden werden.'}}</p>
    <img class="img-fluid mx-auto d-block" src="assets/images/search-list.png">
  </div>
</div>
